import { Routes } from '@angular/router';

import { BuilderRoutes } from './builder/builder.route';
import { RunRoutes } from './run/run.route';

export const ReportRoutes: Routes = [
    {
        children: [...BuilderRoutes, ...RunRoutes],
        path: 'report',
    },
];
